export function getPackage(data) {
    return new Promise((resolve, reject) => {
        let { getPackageRequest, getPackageError, getPackageResult } = this.props

        this.doAction(
            this.WEB_REQUEST_URL + 'get_package',
            this.createBundle(
                'get_package',
                { packageId: data },
                this.GET,
                getPackageRequest,
                (result) => {
                    getPackageResult(result)
                    resolve(result)
                },
                (error) => {
                    getPackageError(error)
                    reject(error)
                }
            )
        )
    })
}
